import { gql } from '@apollo/client';
import { AccountInfoShared, ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionImportLegacyUserToAccount(
    $input: ImportLegacyUserToAccountInput!
  ) {
    actionImportLegacyUserToAccount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      account {
        ...AccountInfoShared
      }
      user {
        id
        firstName
        lastName
        email
        phone
        legacyId
      }
      warnings
    }
  }
  ${ErrorMessageInfo}
  ${AccountInfoShared}
`;
